import { jsonApiVuex } from '@common/store/json-api-vuex';

export const dmsConnectorCredentialFtp = jsonApiVuex(
  'storage_connectors/ftp',
  {},
  {
    moduleName: 'dms/connectorCredentialFtp',
  }
);
